import { saveAs } from "file-saver"

const cell = value => {
    if (value == null)
        return ""
    let text = typeof value === "boolean" ? (value ? "Sim" : "Não") : String(value)
    if (typeof value === "string" && /^[\s]*[=+\-@]/.test(text))
        text = "'" + text
    return /[",;\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text
}

export const downloadCsv = (filename, columns, rows) => {
    const content = [columns.map(column => column.label), ...rows.map(row => columns.map(column => row[column.key]))]
        .map(row => row.map(cell).join(";"))
        .join("\n")
    saveAs(new Blob(["\ufeff", content], { type: "text/csv;charset=utf-8" }), filename)
}
